import { NgModule } from '@angular/core';
import { UteButtonComponent } from './atoms/ute-button/ute-buttons.component';
import { UteIconComponent } from './atoms/ute-icon/ute-icon.component';
import { IonicPageModule } from 'ionic-angular';
import { UteInputComponent } from './atoms/ute-input/ute-input.component';
import { UteRadioComponent } from './atoms/ute-radio/ute-radio.component';
import { UteRadioGroupComponent } from './atoms/ute-radio-group/ute-radio-group.component';
import { TranslateModule } from '@ngx-translate/core';
import { UteToolbarComponent } from './molecules/ute-toolbar/ute-toolbar.component';
import { UteMenuDropdown } from './molecules/ute-menu-dropdown/ute-menu-dropdown.component';
import { UteSimpleCardComponent } from './atoms/ute-simple-card/ute-simple-card.component';
import { UteCheckboxComponent } from './atoms/ute-checkbox/ute-checkbox.component';
import { UteLoaderComponent } from './atoms/ute-loader/ute-loader.component';
import { UteIconSpinnerComponent } from './atoms/ute-icon-spinner/ute-icon-spinner.component';
import { UteHeaderComponent } from './molecules/ute-header/ute-header.component';
import { UteModalComponent } from './molecules/ute-modal/ute-modal.component';

//molecules


const components = [
  UteButtonComponent,
  UteIconComponent,
  UteInputComponent,
  UteRadioComponent,
  UteRadioGroupComponent,
  UteToolbarComponent,
  UteMenuDropdown,
  UteSimpleCardComponent,
  UteCheckboxComponent,
  UteLoaderComponent,
  UteIconSpinnerComponent,
  UteHeaderComponent,
  UteModalComponent
];

@NgModule({
  imports: [
    IonicPageModule,
    TranslateModule.forChild()
  ],
  entryComponents: [
    
  ],
  declarations: components,
  exports: components
})
export class ComponentsModule {};



// WEBPACK FOOTER //
// ./src/app/components/components.module.ts